import { DashboardT } from 'business/definitions';
import _ from 'lodash';

const getLowerTitle = (obj: { title: string }): string =>
    obj.title.toLowerCase();

export const sortDashboardsbyTitle = (dashboards: DashboardT[]): DashboardT[] =>
    // @ts-expect-error [TS migration] Was not detected by flow
    _.sortBy(dashboards, getLowerTitle);
